export default __webpack_public_path__ + "static/media/btn_off.cdd1ee09.svg";